import type { NormalizeOAS, OASOutput, OASRequestParams } from 'fets';
import type { ApiClient } from '../fetsClient';
import type openapi from '../openapi';

type O = NormalizeOAS<typeof openapi>;
type RequestParams = OASRequestParams<O, '/api/scenes/{id}', 'delete'>;
type ResponseBody = OASOutput<O, '/api/scenes/{id}', 'delete'>;

type Params = {
  id: number;
};

type Result = {
  isSuccess: boolean;
  tourIds: number[] | null;
};

export const deleteSceneFactory = (apiClient: ApiClient) => {
  const deleteScene = async (id: number) => {
    const requestBody = mapInputToRequestBody({ id });
    const response = await apiClient['/api/scenes/{id}'].delete(requestBody);
    const responseBody = await response.json();

    return mapResponseToResult(responseBody);
  };

  const mapInputToRequestBody = (input: Params): RequestParams => {
    return {
      params: {
        id: input.id,
      },
    };
  };

  const mapResponseToResult = (response: ResponseBody): Result => {
    return {
      isSuccess: response.isSuccess,
      tourIds: response.tourIds ?? null,
    };
  };

  return deleteScene;
};
